export default __webpack_public_path__ + "static/media/bath_icon.99e0033a.svg";